import { render, staticRenderFns } from "./ScopeOptionsTable.vue?vue&type=template&id=7838dec8&scoped=true"
import script from "./ScopeOptionsTable.vue?vue&type=script&lang=js"
export * from "./ScopeOptionsTable.vue?vue&type=script&lang=js"
import style0 from "./ScopeOptionsTable.vue?vue&type=style&index=0&id=7838dec8&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7838dec8",
  null
  
)

export default component.exports